<div class="modal common-right-modal benefit-modal show" id="addPreferredDruglist" aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel" tabindex="-1" role="dialog" style="display: block; padding-left: 0px;"
  [ngClass]="{'show':showSlider}">
  <div class="modal-dialog modal-half">
    <div class="modal-content">
      <div class="inner-loader-wraper" *ngIf="isLoader">
        <div class="inner-loader"></div>
      </div>
      <ng-container *ngIf="!isLoader">
        <div class="modal-header upload-modal">
          <div class="title-head d-flex align-items-center">
            <button id="btnAddGroupClose" type="button" class="btn-close tool-wrap position-relative"
              data-bs-dismiss="modal" (click)="closePopup()" aria-label="Close">
              <div class="custom-tooltip tooltip-top" role="tooltip">
                <div class="arrow"></div>
                <div class="tooltip-inner"> Close </div>
              </div>
            </button>
            <h2 class="modal-title" id="exampleModalToggleLabel">
              <div class="d-flex align-items-center">
                {{screenType=='diagnosis'?(isEdit?'Edit Diagnosis Code':'Add Diagnosis Code'):(isEdit?'Edit Allergy
                Code':'Add Allergy Code')}}
              </div>
            </h2>
          </div>
          <div class="btn-wrap">
            <button type="button" class="btn btn-outline-secondary" id="Upload-cancel-btn"
              (click)="closePopup()">Cancel</button>
            <button type="button" class="btn btn-primary" id="upload-save-btn"
              (click)="isEdit?updateVersion():addVersion()">{{!isEdit?'Save':'Update'}}</button>
          </div>
        </div>
        <div class="modal-body insurance-modal attach-doc upload-doc" [formGroup]="commonForm">
          <div class="row">
            <div class="col-6 mb-3">
              <div class="form-group">
                <label for="version" class="form-label">{{screenType=='diagnosis'?'Diagnosis Version':'Allergy
                  Version'}}<span class="mandatory">*</span></label>
                <input [ngClass]="{'is-invalid' : submitted && commonForm?.controls?.['version']?.errors?.['required']}"
                  type="text" class="form-control " formControlName="version" id="version" placeholder=""
                  appPreventFirstSpace>
              </div>
              <span *ngIf="submitted && commonForm?.controls?.['version']?.errors?.['required']"
                class="invalid-feedback d-block" tabindex="0">{{requiredMsgError}}</span>

            </div>
            <div class="col-6 mb-3">
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label for="MasterdrugListValidityAdd" class="form-label">Validity
                      Start<span class="mandatory">*</span></label>
                    <app-datepicker_v2 formControlName="validityStart" [field]="validity_date_v2" [disabled]="isEdit"
                      [isInValid]="(submitted && commonForm?.controls?.['validityStart']?.errors?.['required']) || 
                      (commonForm?.controls?.['validityStart']?.errors?.['patternCheck']) ||
                      (commonForm?.controls?.['validityStart']?.errors?.['checkDateWithToday']) || 
                      (commonForm?.controls?.['validityStart']?.errors?.['checkStartDate']) || invalidEndDate()">
                    </app-datepicker_v2>
                  </div>
                  <span *ngIf="submitted && commonForm?.controls?.['validityStart']?.errors?.['required']"
                    class="invalid-feedback d-block" tabindex="0">{{requiredMsgError}}</span>
                  <span *ngIf="commonForm?.controls?.['validityStart']?.errors?.['patternCheck']"
                    class="invalid-feedback d-block" tabindex="0">{{validationMsg}}</span>
                  <span *ngIf="commonForm?.controls?.['validityStart']?.errors?.['checkDateWithToday'] && !isEdit"
                    class="invalid-feedback d-block" tabindex="0">Start date must be greater than or equal to
                    today</span>

                  <span *ngIf="commonForm?.controls?.['validityStart']?.errors?.['checkStartDate']"
                    class="invalid-feedback d-block" tabindex="0">{{startDateError}}</span>
                  <span *ngIf="invalidEndDate() && !isEdit" class="invalid-feedback d-block"
                    tabindex="0">{{startDateError}}</span>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label for="MasterdrugListValidityAdd" class="form-label">Validity
                      End<span class="mandatory">*</span></label>
                    <app-datepicker_v2 formControlName="validityEnd" [field]="validity_date_v2" [disabled]="isEdit"
                      [isInValid]="(submitted && commonForm?.controls?.['validityEnd']?.errors?.['required']) ||
                      (commonForm?.controls?.['validityEnd']?.errors?.['patternCheck']) || (commonForm?.controls?.['validityEnd']?.errors?.['checkDateWithToday'])">
                    </app-datepicker_v2>
                  </div>
                  <span *ngIf="submitted && commonForm?.controls?.['validityEnd']?.errors?.['required']"
                    class="invalid-feedback d-block" tabindex="0">{{requiredMsgError}}</span>
                  <span *ngIf="commonForm?.controls?.['validityEnd']?.errors?.['patternCheck']"
                    class="invalid-feedback d-block" tabindex="0">{{validationMsg}}</span>
                  <span *ngIf="commonForm?.controls?.['validityEnd']?.errors?.['checkDateWithToday'] "
                    class="invalid-feedback d-block" tabindex="0">End Date Must be greater than
                    or equal to today</span>
                  <span *ngIf="invalidEndDate() && isEdit" class="invalid-feedback d-block"
                    tabindex="0">{{startDateError}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-3">
              <div class="form-group">
                <label for="UploadDLDesc" class="form-label ">Description</label>
                <textarea id="UploadDLDesc" formControlName="description"
                  class="form-control min-height-text-area"></textarea>
              </div>
            </div>
          </div>
          <div class="row"
            *ngIf="!isEdit && (checkPermission('downloadDiagnosisTemplate') || checkPermission('downloadAllergyTemplate'))">
            <div class="col-12">
              <div class="btn-download">
                <a>
                  <div class="" (click)="downloadTemplate()">
                    <img src="assets/images/icons/download.svg" alt="download icon" />
                    DOWNLOAD TEMPLATE
                  </div>
                </a>
              </div>
            </div>
            <app-upload-file *ngIf="!isEdit && !showValidation" (uplaodedFiles)="uploadedFiles($event)"
              [file]="uploadFiles" [submitted]="submitted" [progress]="progress"></app-upload-file>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>